module.exports = __webpack_public_path__ + "static/assets/dbba3b28ccd868e668fd4c2ede85ead4.gif";